export const admissions = {
  title: "Admissions Process",
  subtitle: "We accompany you every step of the way to becoming part of our educational community",
  process: {
    title: "Steps to join Gándara",
    steps: [
      {
        title: "Initial contact",
        description: "Contact us by phone, email, or through our website to express your interest."
      },
      {
        title: "Guided visit",
        description: "Book a visit to see our facilities, methodology, and educational team. You can resolve all your doubts."
      },
      {
        title: "Admission application",
        description: "Complete the application form with your child's and family's information."
      },
      {
        title: "Family interview",
        description: "We'll have a conversation with the family to get to know you better and ensure we share values and expectations."
      },
      {
        title: "Confirmation and enrollment",
        description: "If places are available and both parties agree, we'll proceed with formalizing the enrollment."
      }
    ]
  },
  requirements: {
    title: "Required documentation",
    items: [
      "Complete registration form",
      "Copy of student's ID/Passport",
      "Copy of parents'/guardians' ID",
      "Birth certificate",
      "Updated medical certificate",
      "Recent passport-size photo",
      "Proof of enrollment fee payment"
    ]
  },
  visit: {
    title: "Book your visit",
    description: "The first step is getting to know us. Schedule a visit to discover Gándara.",
    button: "Schedule visit"
  },
  contact: {
    title: "Have questions?",
    description: "We're here to help. Contact us and we'll answer all your questions.",
    button: "Contact us"
  }
};
